// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".letter-spacing-none[data-v-b6640e22]{letter-spacing:0!important}pre[data-v-b6640e22]{font-family:vazir,serif;color:unset!important}", ""]);
// Exports
module.exports = exports;
